import { Progress } from 'antd';
import React from 'react';
import './style.scss';

export const ProviderProgressBar = ({ title, percent }) => (
  <div className="provider_progressbar">
    <div className="provider_progressbar_header">
      <p>{title}</p>
      <p>{percent === 0 ? '--' : percent} %</p>
    </div>
    <Progress
      percent={percent}
      format={() => {
      }}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/ProviderProgressBar/index.js